import {
  AssetTypeAddList,
  UpdateAssetListSliceState,
  typeChangeSpecificationsList,
  typeChangeSpecificationsProps,
} from '../../../../types/Assets/AssetList/addEditListTypes'
import { AllAssetsList } from '../../../../types/Assets/AssetList/AssetListTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, getAddAssetListConfig } from '../../apiList'

const getAddAssetList = async (
  data: AssetTypeAddList,
): Promise<AssetTypeAddList[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: getAddAssetListConfig.addAsset,
    method: AllowedHttpMethods.post,
    data,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const updateAssetList = async (
  data: UpdateAssetListSliceState,
): Promise<UpdateAssetListSliceState> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: getAddAssetListConfig.updateAsset,
    method: AllowedHttpMethods.put,
    data,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const checkAssetNumberExixts = async (
  AssetNumber: string,
): Promise<boolean> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: getAddAssetListConfig.checkAssetNumberExixts,
    method: AllowedHttpMethods.get,
    params: {
      AssetNumber,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const typeChangeSpecifications = async (
  props: typeChangeSpecificationsProps,
): Promise<typeChangeSpecificationsList[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: getAddAssetListConfig.typeChangeSpecifications,
    method: AllowedHttpMethods.get,
    params: {
      manufacturerId: props.manufacturerId,
      productId: props.productId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getCopyAssetList = async (id: number): Promise<AllAssetsList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: getAddAssetListConfig.getCopyAssetList,
    method: AllowedHttpMethods.get,
    params: {
      assetId: id,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const AddEditAssetListApi = {
  getAddAssetList,
  updateAddAsset: updateAssetList,
  checkAssetNumberExixts,
  typeChangeSpecifications,
  getCopyAssetList,
}
export default AddEditAssetListApi
